/* eslint-disable no-magic-numbers */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { fastlyUrl } from "../../../utils/helpers/cdn-image-url";
const CarUspContainer = ({ slideData = {}, isInnerGallery = false, config }) => {
    const { title = "", items = [] } = slideData || {};
    const getIconUrl = (icon) => {
        return fastlyUrl(config?.brandImageHost, icon);
    };
    return (
        <React.Fragment>
            <div styleName={`styles.premiumFeatureWrap ${isInnerGallery ? "styles.innerGallery" : ""}`}>
                <p styleName={`styles.premiumFeatureHeading ${isInnerGallery ? "styles.innerheading" : ""}`}>{title}</p>
                <div styleName={"styles.outer"}>
                    {items.map((item) => (
                        <div className="media" styleName={"styles.mediaContainer"}>
                            <img src={getIconUrl(item.icon)} />
                            <div className="media-body">
                                <p styleName={"styles.premiumFeature"}>{item?.label}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
};

CarUspContainer.propTypes = {
    slideData: PropTypes.object,
    isInnerGallery: PropTypes.bool,
    config: PropTypes.object
};

export default CarUspContainer;
